import dayjs, { Dayjs } from 'dayjs'
import { SimpleFilter } from '../../types/strapi/strapi'

export default function getBetweenByOneDate(date: Dayjs): SimpleFilter {
    return {
        $between: [
            dayjs(date).startOf('day').toISOString(),
            dayjs(date).endOf('day').toISOString(),
        ],
    }
}
